import React from 'react';
import "./slider.css";

export default function SliderCard() {
  return (
    <>


<div id="ThumbnailCarousel" class="carousel slide col-xs-12" data-ride="carousel">
  <div class="carousel-inner">
    <div class="carousel-item active">
      <div class="row">
          <div class="col-md-3 col-sm-6"><span class="thumbnail">
              
              <img src="https://s3.amazonaws.com/ooomf-com-files/tU3ptNgGSP6U2fE67Gvy_SYDNEY-162.jpg" alt="Image" class="img-fluid img-thumbnail" />

              </span>
          
          </div>
          <div class="col-md-3 col-sm-6"><span class="thumbnail">
             
              <img src="https://s3.amazonaws.com/ooomf-com-files/tU3ptNgGSP6U2fE67Gvy_SYDNEY-162.jpg" alt="Image" class="img-fluid img-thumbnail" />
              </span>
          
          </div>
          <div class="col-md-3 col-sm-6"><span class="thumbnail">
              
              
              <img src="https://s3.amazonaws.com/ooomf-com-files/tU3ptNgGSP6U2fE67Gvy_SYDNEY-162.jpg" alt="Image" class="img-fluid img-thumbnail" /></span>
          
          </div>
          <div class="col-md-3 col-sm-6"><span class="thumbnail"><img src="https://s3.amazonaws.com/ooomf-com-files/tU3ptNgGSP6U2fE67Gvy_SYDNEY-162.jpg" alt="Image" class="img-fluid img-thumbnail" /></span>
          </div>
      </div>
    </div>
    <div class="carousel-item">
      <div class="row">
          <div class="col-md-3 col-sm-6"><span class="thumbnail">
              
              <img src="https://s3.amazonaws.com/ooomf-com-files/tU3ptNgGSP6U2fE67Gvy_SYDNEY-162.jpg" alt="Image" class="img-fluid img-thumbnail" /></span>
          
          </div>
          <div class="col-md-3 col-sm-6"><span class="thumbnail">
              
              <img src="https://s3.amazonaws.com/ooomf-com-files/tU3ptNgGSP6U2fE67Gvy_SYDNEY-162.jpg" alt="Image" class="img-fluid img-thumbnail" /></span>
          
          </div>
          <div class="col-md-3 col-sm-6"><span class="thumbnail"><img src="https://s3.amazonaws.com/ooomf-com-files/tU3ptNgGSP6U2fE67Gvy_SYDNEY-162.jpg" alt="Image" class="img-fluid img-thumbnail" /></span>
          </div>
          <div class="col-md-3 col-sm-6"><span class="thumbnail"><img src="https://s3.amazonaws.com/ooomf-com-files/tU3ptNgGSP6U2fE67Gvy_SYDNEY-162.jpg" alt="Image" class="img-fluid img-thumbnail" /></span>
          </div>
      </div>
    </div>
    <div class="carousel-item">
      <div class="row">
          <div class="col-md-3 col-sm-6"><span class="thumbnail">
              <img src="https://s3.amazonaws.com/ooomf-com-files/tU3ptNgGSP6U2fE67Gvy_SYDNEY-162.jpg" alt="Image" class="img-fluid img-thumbnail" /></span>
          </div>
          <div class="col-md-3 col-sm-6"><span class="thumbnail"><img src="https://s3.amazonaws.com/ooomf-com-files/tU3ptNgGSP6U2fE67Gvy_SYDNEY-162.jpg" alt="Image" class="img-fluid img-thumbnail" /></span>
          </div>
          <div class="col-md-3 col-sm-6"><span class="thumbnail"><img src="https://s3.amazonaws.com/ooomf-com-files/tU3ptNgGSP6U2fE67Gvy_SYDNEY-162.jpg" alt="Image" class="img-fluid img-thumbnail" /></span>
          </div>
          <div class="col-md-3 col-sm-6"><span class="thumbnail"><img src="https://s3.amazonaws.com/ooomf-com-files/tU3ptNgGSP6U2fE67Gvy_SYDNEY-162.jpg" alt="Image" class="img-fluid img-thumbnail" /></span>
          </div>
      </div>
    </div>
  </div>
  <span class="carousel-control-prev " href="#ThumbnailCarousel" role="button" data-slide="prev">
    <span class="carousel-control-prev-icon " aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </span>
  <span class="carousel-control-next " href="#ThumbnailCarousel" role="button" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </span>
</div>




        </>
  );
}
